/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import { date } from '../../../../../../@launchpad/util/DateHelper';
import { LPOverridable } from '../../../../../../@launchpad/components';
import { LoadingOverlay } from '../../../../../../@launchpad/index';
import UserTierUserInfoElement from '../../../../../../@launchpad/modules/users/user-tiers/components/UserTierUserInfoElement';
import { camelCaseToHumanReadable } from '@launchpad/util/StringHelper';
import EditPhoneModal from './components/EditPhoneModal';

class CustomerBasicInfo extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.state = {
      redirect: false,
      showEditPhoneModal: false
    };
  }

  parseIfValidJson(jsonString) {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      return undefined;
    }
  }

  render() {
    const { user } = this.props;

    if (this.state.redirect) {
      return <Redirect to={`/user-details/${user.id}`} />;
    }

    if (!user.id) {
      return <LoadingOverlay />;
    }

    const complianceDataString = this.parseIfValidJson(
      user.additionalData?.compliance
    );

    return (
      <div className="main" key={user}>
        <div className="dark-blur" />
        <div className="customers-info">
          <div className="customer-details">
            <div>
              <h2 className="customer-name">
                <span className="company">
                  {user.firstName} {user.lastName}
                </span>
              </h2>
            </div>
            <div>
              <div className="bottom" style={{ alignItems: 'center' }}>
                <Link
                  to={`/user-details/${user.id}/edit`}
                  className="button-info"
                  style={{ minWidth: 100 }}
                >
                  Edit
                </Link>
              </div>
            </div>
          </div>
          <div className="customers-main">
            <div className="row">
              <div className="col">
                {!user ? (
                  <LoadingOverlay />
                ) : (
                  <div className="padded">
                    <LPOverridable
                      name="user.details.basic.before"
                      user={user}
                    />
                    <div className="row text-white">
                      <div style={{ marginBottom: 20 }} className="col-lg-6">
                        <h4>Basic Info</h4>
                        <hr />
                        <dl>
                          <dt>First name:</dt>
                          <dd>{user.firstName || '-'}</dd>
                          <dt>Last name:</dt>
                          <dd>{user.lastName || '-'}</dd>
                          <dt>Username:</dt>
                          <dd>{user.username ? user.username : '-'}</dd>
                          <dt>E-mail address:</dt>
                          <dd>{user.email || '-'}</dd>
                          <dt>Customer id:</dt>
                          <dd>{user.id || '-'}</dd>
                          <dt>Birth date:</dt>
                          <dd>{date(user.birthDate, 'D / MMMM / Y') || '-'}</dd>
                          <dt>Onboarding:</dt>
                          <dd>
                            {date(user.registeredAt, 'D / MMMM / Y HH:mm') ||
                              '-'}
                          </dd>
                          {complianceDataString && (
                            <>
                              {Object.entries(complianceDataString).map(
                                ([key, value]) => (
                                  <>
                                    <dt>{camelCaseToHumanReadable(key)}:</dt>
                                    <dd>
                                      {typeof value === 'boolean'
                                        ? value
                                          ? 'Yes'
                                          : 'No'
                                        : Array.isArray(value)
                                        ? value.join(', ')
                                        : value || '-'}
                                    </dd>
                                  </>
                                )
                              )}
                            </>
                          )}
                        </dl>
                      </div>
                      <div style={{ marginBottom: 20 }} className="col-lg-6">
                        <h4>Address Info</h4>
                        <hr />
                        <dl>
                          <dt>Address Line One:</dt>
                          <dd>{user.addressOne || '-'}</dd>
                          <dt>Address Line Two:</dt>
                          <dd>{user.addressTwo || '-'}</dd>
                          <dt>City:</dt>
                          <dd>{user.city || '-'}</dd>
                          <dt>Postcode:</dt>
                          <dd>{user.postCode || '-'}</dd>
                          <dt>Country code:</dt>
                          <dd>{user.countryCode || '-'}</dd>
                          <dt>Mobile:</dt>
                          <dd>
                            {user.phoneNumber || '-'}{' '}
                            <i
                              onClick={() =>
                                this.setState({ showEditPhoneModal: true })
                              }
                              style={{ marginLeft: 5, cursor: 'pointer' }}
                              className="fa fa-fw fa-pencil"
                            />
                            <EditPhoneModal
                              visible={this.state.showEditPhoneModal}
                              userId={user.id}
                              phoneNumber={user.phoneNumber}
                              onClose={() =>
                                this.setState({ showEditPhoneModal: false })
                              }
                              onSuccess={() => {
                                this.setState({ showEditPhoneModal: false });
                                window.location.reload();
                              }}
                            />
                          </dd>
                        </dl>
                        <div style={{ marginTop: 20 }}>
                          <UserTierUserInfoElement
                            user={user}
                            onSuccess={() => window.location.reload()}
                          />
                        </div>
                      </div>

                      <div style={{ marginBottom: 20 }} className="col-lg-6">
                        <h4>User errors</h4>
                        <hr />
                        {user.userErrors && user.userErrors.length > 0 ? (
                          user.userErrors.map(e => (
                            <>
                              <span>{e.errorMessage || '-'}</span>
                              <br />
                              <br />
                            </>
                          ))
                        ) : (
                          <span>No errors</span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CustomerBasicInfo);
